module.exports = "/_next/static/images/WantToRetainCustomers-sm@2x-fb53c866542ccbce4cb0d24a54fd8619.webp";